export const statusReportStoreKey = 'statusReport';
